<template>
	<Teleport to="#app">
		<ul v-if="toastStore.toasts.length" class="toast-wrapper">
			<li
				v-for="toast in toastStore.toasts"
				:key="toast.id"
				:class="['toast', toast.status]"
				@click="toastStore.closeToast(toast)"
			>
				<div class="left">
					<img :src="toastIconMap[toast.status]" class="toast-icon" />
					<component :is="toast.content" v-if="typeof toast.content !== 'string'" v-bind="toast.props" />
				</div>

				<XIcon class="close-icon" />
			</li>
		</ul>
	</Teleport>
</template>

<script setup lang="ts">
import { useToastStore, type TToastStatus } from '../stores/useToastStore';
import warningSvg from '@/assets/icons/warning.svg?url';
import checkCircleSvg from '@/assets/icons/check-circle.svg?url';
import XIcon from '@/assets/icons/X.svg';

const toastIconMap: Record<TToastStatus, string> = {
	error: warningSvg,
	success: checkCircleSvg
};

const toastStore = useToastStore();
</script>

<style scoped>
.toast {
	box-sizing: border-box;

	background: linear-gradient(0deg, rgba(155, 255, 171, 0.05), rgba(155, 255, 171, 0.05)), #00050d;
	border-radius: 16px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 300;
	font-size: 11px;
	line-height: 13px;

	border: 1px solid rgba(155, 255, 171, 0.2);

	color: rgba(255, 255, 255, 0.7);

	display: flex;
	flex-direction: row;
	justify-content: space-between;

	cursor: pointer;
}

.toast-wrapper {
	z-index: 100;
	position: absolute;
	bottom: 0px;
	left: 0px;
	right: 0px;

	display: flex;
	flex-direction: column;
	padding: 16px;
	gap: 10px;
}

.left {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.close-icon {
	padding: 6px;
	width: 15px;
	height: 15px;
}

.error {
	background: linear-gradient(0deg, rgba(255, 32, 0, 0.05), rgba(255, 32, 0, 0.05)), #00050d;
}

/* .success {
	width: 32px;
	height: 32px;

	filter: drop-shadow(0px 0px 15px rgba(155, 255, 171, 0.5));
} */
</style>
